import type { TWithdrawalMethod, TWithdrawalMethodServer } from '../../store/types';

export const withdrawalMethodsAdapter = (items: TWithdrawalMethodServer[]): TWithdrawalMethod[] => items.map((item) => ({
  id: item.id,
  name: item.name,
  currency: item.currency,
  minAmount: Number(item.min_amount),
  maxAmount: Number(item.max_amount),
  active: item.active,
  withdrawalPercent: Number(item.withdrawal_percent),
  withdrawalFee: Number(item.withdrawal_fee),
}));
